// Page Three map slides

import Swiper, { Thumbs } from "swiper";
Swiper.use([ Thumbs ]);

// Labels
const mapLabels = new Swiper('.jsMapLabels',
{
	allowTouchMove: false,
	slidesPerView: 3,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
});
// Maps
const mapSlides = new Swiper('.jsMaps',
{
	thumbs:
	{
		swiper: mapLabels
	}
});

// Lightboxes
/* const lightboxTriggers = document.querySelectorAll('.jsLightboxInit');

lightboxTriggers.forEach( lightboxTrigger => {
	lightboxTrigger.addEventListener('click', (e) => {
		e.preventDefault();
		let targetLightbox = document.querySelector(lightboxTrigger.getAttribute('href'));
		targetLightbox.classList.add('-isVisible');
	} );
} );

const lightboxCloseButtons = document.querySelectorAll('.jsLightboxClose');

lightboxCloseButtons.forEach( lightboxCloseButton => {
	lightboxCloseButton.addEventListener('click', (e) => {
		e.preventDefault();
		let boxToClose = lightboxCloseButton.closest('.lightbox');
		boxToClose.classList.remove('-isVisible');
	});
}); */